import { render, staticRenderFns } from "./priceListMagytrack.vue?vue&type=template&id=6ec43c86&"
import script from "./priceListMagytrack.vue?vue&type=script&lang=js&"
export * from "./priceListMagytrack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports